<script lang="ts">
	import Spinner from "../atoms/Spinner.svelte"
	export let klass = ''
	export let color = ''
	export let text = 'text-white'
	export let border = 'border-none'
	export let full = false
	export let rounded = false
	export let loading = false
	export let disabled = false
	export let click = () => {
		console.log('Not implemented')
	}
</script>

<button
	class="transition-color {color} duration-300 {text} p-3 {klass} w-28 text-sm font-semibold tracking-widest {border}"
	class:w-full={full}
	class:rounded-xl={rounded}
	on:click={click}
	disabled={disabled}
>
	<div class="flex justify-center">
		{#if loading}
			<Spinner klass="mr-2" />
		{/if}
		<slot></slot>
	</div>
</button>